import { useChatConfig, useChatController } from '@healthpilot/acars'
import { runtime } from 'std-env'
import { PlanType } from '~/generated/api-clients-generated'

export default class PxChat {
  static use() {
    const show = (params?: Object | null | undefined) => {
      const { show: showChat } = useChatController()
      const profile = ProfileStore.use()
      const session = SessionStore.use()
      const { route, path } = AppRoute.use()
      const { getAnonymousId } = Analytics.use()
      const { isAuthenticated } = Auth.use()

      const runtimeConfig = useRuntimeConfig()

      showChat({
        ProfileId: profile.id,
        DisplayName: profile.firstName ?? 'You',
        Domain: 'PX',
        PlanType: !!session.planType ? PlanType[session.planType] : null,
        Path: route.path?.toString(),
        Env: runtimeConfig.public.sentryEnv,
        RdAnonId: getAnonymousId(),
        PxAuthenticated: isAuthenticated.value?.toString() ?? 'false',
        //purposefully inconsistent casing for ~reasons~
        zipcode: profile.location?.zipCode,
        county: profile.location?.countyName,
        ...(params ?? {})
      })
    }

    const configure = () => {
      const { setConfig } = useChatConfig()
      const runtimeConfig = useRuntimeConfig()

      setConfig({
        connectBaseUrl: runtimeConfig.public.connectApiBaseUrl,
        connectInstanceId: runtimeConfig.public.connectInstanceId,
        connectInstanceRegion: runtimeConfig.public.connectInstanceRegion,
        connectFlowId: runtimeConfig.public.connectContactFlowId,
        cookieDomain: runtimeConfig.public.acarsCookieDomain,
        cookiePrefix: runtimeConfig.public.acarsCookiePrefix
      })
    }

    const { unreadMessages } = useChatController()

    return {
      show,
      configure,
      unreadMessages
    }
  }

  static show(params?: Object | null | undefined) {
    const { show, configure } = PxChat.use()
    configure()
    show(params)
  }
}
